import React, {useState, useEffect, useRef} from 'react';
// import React, {useState, useEffect} from 'react';
import {useParams, Link} from 'react-router-dom';
import styled from 'styled-components';

import { Chart as ChartJS, registerables } from 'chart.js';
import { Doughnut, Chart, Line, Bar } from 'react-chartjs-2';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';

import {BORDER, BITTERSWEET, CHETWODEBLUE, SILVERTREE, LILAC, OzButton, OzCopyable, OzTooltip, OzTable, OzContainer, OzRow, OzCol, OzCard, OzIcon, OzProjectTag} from '@ozwol/webui';

import AccountService from './../../services/AccountService';
// import UsersService from './../../services/UsersService';
import ProjectsService from './../../services/ProjectsService';
import LogsService from './../../services/LogsService';
import UsagesService from './../../services/UsagesService';

// import ReferencePeriodTimeline from './../../chunks/ReferencePeriodTimeline';
// import LogToggle from './../../components/LogToggle';
import Meta from './../../components/Meta'; 
import PageHeader from '../../components/PageHeader';
import HealthyWrapper from '../../components/HealthyWrapper';
import CardHeaderTitle from '../../components/CardHeaderTitle';
// import MegaTooltip from '../../components/MegaTooltip';
import ChartWrapper from '../../components/ChartWrapper';

import {getWeekOfYear, getArrayOfDayHours, getChartOptions, changeDate, checkPermission, getArrayFromInterval, formatError, convertNumber, convertSize, getFormattedDate, getFormattedTime, getWeekDay, isSameDate} from './../../helpers';

const USAGES_INDEX_COLUMN = 1;
const USAGES_ASSETS_COLUMN = 2;
const USAGES_CREDITS_COLUMN = 3;
const USAGES_STORAGE_COLUMN = 4;
const USAGES_TRANSFER_COLUMN = 5;

ChartJS.register(MatrixController, MatrixElement, ...registerables);

const Detail = styled.div`
  text-transform: uppercase;
  color: ${CHETWODEBLUE};
  
  font-size: 12px;
`;

const CardPhraseCollapsed = styled.div`
  min-width: 160px;
  text-align: right;
  display: flex;
  justify-content: end;
  height: 100%;
`;

const CardPhrase = styled.div`

  display: flex;
  align-items: center;
  height: 100%;
`;

const CardPhraseText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #303030;
  position: relative;
  top: 2px;

  display: flex;
  // align-items: baseline;
`;
const CardPhraseSuperNumber = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #303030;
  margin: 0px 5px;
  position: relative;
  top: -2px;
`;

const MegaBadgeCnt = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

const MegaBadge = styled.div`
  background: #ffffff;
  border: 2px solid ${props => props.variant === "today" ? SILVERTREE+"60" : LILAC};
  color: #303030;
  text-align: center;
  display: inline-block;
  width: 100%;
  padding: 15px 15px;
  font-size: 20px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
`;


const ChartModeContainer = styled.div`
  display: flex;
`;
const ChartModeButton = styled.div`
  background-color: ${props => props.active ? CHETWODEBLUE : CHETWODEBLUE+"12"};
  color: ${props => props.active ? "#ffffff" : "#303030"};
  padding: 1px 7px;
  border-radius: 3px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const NoLog = styled.div`
  text-align: center;
  padding: 50px;
  font-size: 12px;
  font-weight: 400;
`;
const NoLogSmall = styled.div`
  text-align: center;
  padding: 0px;
  font-size: 12px;
  font-weight: 400;
`;

// const ChartTotal = styled.div`
//   color: #30303099;
//   font-size: 12px;
//   font-weight: 400;
// `;

const LogTableWrapper = styled.div`
  & table tr td{
    white-space: nowrap;
  }
  & table tr td:nth-child(1),
  & table tr td:nth-child(2),
  & table tr td:nth-child(3){
    word-break: break-all;
    white-space: unset;
  }
`;
const LogCost = styled.div`
  text-align: center;
`;
const LogExecution = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 10px;
  color: ${props => props.status === "ERROR" ? "#FF4848" : props.status === "WARNING" ? "#FFB100" : "#4AD384"};
  margin: 0 auto;
`;

const Dark = styled.div`;
  font-size: 12px;
`;
const Light = styled.div`
  color: #30303099;
  font-size: 12px;
`;
const Accordion = styled.div`
  display: flex;
  font-size: 12px;

  & table{
    width: 100%;
  }
  & table,
  & table *{
    border: 0 !important;
    background: transparent !important;
  }
`;
const AccordionLeft = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  width: ${props => props.full ? "100%" : "60%"};

  & *{
    white-space: normal;
  }
  & b{
    white-space: nowrap;
  }
`;
const AccordionRight = styled.div`
  color: ${BITTERSWEET};
  flex-grow: 0;
  flex-shrink: 0;
  width: 40%;
`;
const LogRow = styled.tr`
  display: flex;
  padding-bottom: 3px;
  padding-left: 20px;
`;
const LogKey = styled.td`
  flex-grow: 0;
  flex-shrink: 0;
  width: 120px;
  white-space: nowrap;
  font-weight: 600;
`;
const LogValue = styled.td`
  flex-grow: 1;
  flex-shrink: 1;
  white-space: normal; 
  width: calc(100% - 120px);
`;

const AssetsCnt = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
const AssetsBlock = styled.div`
  margin-bottom: 50px;
  & > *{
    margin-top: -10px;
    margin-bottom: -10px;
  }
`;

const Calendar = styled.div`
  width: 100%;
`;
const ScrollRef = styled.div`
  scroll-margin: 70px;
`;

// const CreditsDashboard = styled.div`
//   display: flex;
//   flex-direction: row;
//   height: 100%;
// `;
// const CreditsDashboardLeft = styled.div`
//   flex-grow: 1;
//   flex-shrink: 1;
//   width: calc(100% - 185px);
//   & > * {
//     width: 100%;
//     border-top-right-radius: 0px;
//     border-bottom-right-radius: 0px;    
//   }
// `;
// const CreditsDashboardRight = styled.div`
//   flex-grow: 0;
//   flex-shrink: 0;
//   width: 185px;
//   & > * {
//     width: 100%;
//     padding: 0px;
//     border-top-left-radius: 0px;
//     border-bottom-left-radius: 0px;   
//     border-left: 0px;
//   }
// `;
// const CreditsGrid = styled.div`
//   height: 100%;
//   display: grid;
//   grid-template-columns: 1fr;
//   grid-template-rows: repeat(${props => props.slot},1fr);
// `;
// const CreditsGridBox = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   padding: 0px 30px 0px;
//   text-align: right;
//   &:not(:first-child){
//     border-top: 1px solid #d5d9ed;
//   }

//   background: ${props => props.important ? LILAC : "#ffffff"};
//   color: ${props => props.important ? CHETWODEBLUE : "#303030"};
// `;
// const CreditsGridLabel = styled.div`
//   // border: 1px solid lime;
//   font-size: 11px;
// `;
// const CreditsGridValue = styled.div`
//   display: inline-block;
//   width: 100%;
//   font-size: 16px;
//   font-weight: 600;
//   line-height: 16px;
//   white-space: nowrap;
//   margin-top: 1px;
// `;

const DashGrid = styled.div`
  height: 100%;
  display: grid;
	gap: 20px;
	// grid-template-columns: 2fr 1fr;
	// grid-template-rows: repeat(2, auto);
	grid-template-columns: repeat(6, 1fr);
	grid-template-rows: repeat(2, auto);
`;
const DashGridL1 = styled.div`
	// grid-area: 1 / 1 / 2 / 3;
	grid-area: 1 / 1 / 2 / 5;
`;
const DashGridL2 = styled.div`
	// grid-area: 2 / 1 / 3 / 2;
	grid-area: 2 / 1 / 3 / 4; 
`;
const DashGridL3 = styled.div`
	// grid-area: 2 / 2 / 3 / 3;
	grid-area: 2 / 4 / 3 / 7; 
`;
const DashGridR = styled.div`
	// grid-area: 1 / 3 / 3 / 4;
	grid-area: 1 / 5 / 2 / 7;
`;

const CreditsDashboard = styled.div`
  display: flex;
  flex-direction: row;
	height: 100%;
`;
const CreditsDashboardLeft = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  width: calc(100% - 250px);
  & > * {
    width: 100%;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;    
  }
`;
const CreditsDashboardRight = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  width: 250px;
  & > * {
    width: 100%;
    padding: 0px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;   
    border-left: 0px;
  }
`;
const CreditsGrid = styled.div`
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(${props => props.slot},1fr);
`;
const CreditsGridBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 30px 0px;
  text-align: right;
  &:not(:first-child){
    border-top: 1px solid #d5d9ed;
  }

  background: ${props => props.important ? LILAC : "#ffffff"};
  color: ${props => props.important ? CHETWODEBLUE : "#303030"};
`;
const CreditsGridLabel = styled.div`
  // border: 1px solid lime;
  font-size: 11px;
`;
const CreditsGridValue = styled.div`
  display: inline-block;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
  margin-top: 1px;
`;
const MiniChartWrapper = styled.div`
  height: 50px;
  margin-top: 10px;
`;


const Matrix = props => <Chart type="matrix" {...props} />

const Dashboard = ({refScrollerPage}) => {
  const GRAPH_MODE_DELTA = 0;
  const GRAPH_MODE_SUM = 1;
  

  const {projectUuid} = useParams();
  const [project, setProject] = useState(null);
  const [period, setPeriod] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(-1);
  const [periodHistory, setPeriodHistory] = useState(null);
  const [logs, setLogs] = useState(null);
  const [dayForHourlyDetail, setDayForHourlyDetail] = useState(null);
  const [graphMode, setGraphMode] = useState(GRAPH_MODE_DELTA);
  const [showLimit, setShowLimit] = useState(false);
  
  // const [listUsers, setListUsers] = useState([]);
  const [listProjects, setListProjects] = useState([]);

  const scrollToCredits = useRef();
  const [collapsedCredits, setCollapsedCredits] = useState(false);
  const scrollToStorage = useRef();
  const [collapsedStorage, setCollapsedStorage] = useState(true);
  const scrollToTransfer = useRef();
  const [collapsedTransfer, setCollapsedTransfer] = useState(true);
  const scrollToAssets = useRef();
  const [collapsedAssets, setCollapsedAssets] = useState(false);

  const [arrayOfDays, setArrayOfDays] = useState([]);
  
  const [usagesCreditsConsumed, setUsagesCreditsConsumed] = useState(null);
  const [usagesStorageInUse, setUsagesStorageInUse] = useState(null);
  const [usagesTransferConsumed, setUsagesTransferConsumed] = useState(null);
  const [usagesAssetsProcessed, setUsagesAssetsProcessed] = useState(null);
  const [usagesAssetsProcessedToday, setUsagesAssetsProcessedToday] = useState(null);
  const [usagesDoughnut, setUsagesDoughnut] = useState(null);
  const [usagesHeatmap, setUsagesHeatmap] = useState(null);
  const [usagesLineMiniAssets, setUsagesLineMiniAssets] = useState(null);
  const [usagesBarAssets, setUsagesBarAssets] = useState(null);
  const [usagesBarCredits, setUsagesBarCredits] = useState(null);
  const [usagesLineCredits, setUsagesLineCredits] = useState(null);
  const [usagesLineMiniCredits, setUsagesLineMiniCredits] = useState(null);
  const [usagesBarStorage, setUsagesBarStorage] = useState(null);
  const [usagesLineMiniStorage, setUsagesLineMiniStorage] = useState(null);
  const [usagesBarTransfer, setUsagesBarTransfer] = useState(null);
  const [usagesLineMiniTransfer, setUsagesLineMiniTransfer] = useState(null);

  const [detailedDay, setDetailedDay] = useState(null);
  const [usagesDetailedBarCredits, setUsagesDetailedBarCredits] = useState(null);

  const [fetchError, setFetchError] = useState(false);


  useEffect(() => {
    if(checkPermission("project", "read")){
      ProjectsService.get(projectUuid).then((response) => {
        setProject(response);
        setPeriod(null);
      }).catch((error) => {
        setFetchError(formatError(error));
      });
    }
  }, [projectUuid]);

  useEffect(() => {
    if(checkPermission("period", "read") && checkPermission("period", "list")){
      if(period === null || selectedPeriod !== period.sequenceNumber){
        AccountService.getPeriod({
          "includeRecharges": true
        }, selectedPeriod).then((response1) => {
          if(response1 && response1){
            if(period === null){
              if(checkPermission("log", "list")){
                LogsService.list("", {
                  "project_uuid": projectUuid,
                  "start": response1.startDate,
                  "end": response1.currentPlan.planType === "PAID" ? response1.endDate : null
                }).then((response) => {
                  setLogs(response.hits.splice(0,10));
                }).catch((error) => {
                  setLogs(null);
                  setFetchError(formatError(error));
                });
              }
            }
            setPeriod(response1);
            setSelectedPeriod(response1.sequenceNumber);
            if(project && response1.currentPlan){  
              setArrayOfDays(getArrayFromInterval(response1.startDate, response1.endDate ? response1.endDate : new Date(), "day"));
            }
          }  
        }).catch((error) => {
          setFetchError(formatError(error));
        });
      }
    }else{
      if(checkPermission("log", "list")){
        LogsService.list("", {
          "project_uuid": projectUuid,
          "start": changeDate(Date.now(), -7, "days"),
        }).then((response) => {
          setLogs(response.hits.splice(0,10));
        }).catch((error) => {
          setLogs(null);
          setFetchError(formatError(error));
        });
      }
    }
  }, [period, selectedPeriod, projectUuid, project]);

  useEffect(() => {
    if(period && arrayOfDays.length > 0){
      let params = {};
      params.projectUuid = projectUuid;
      params.grain = "d";
      params.hideTrivial = false;
      params.start = period.startDate;
      params.end = period.endDate; 
      UsagesService.listByProjects(params).then((usages) => {    
        let creditsConsumed = usages.dataset.reduce((accumulator, currentValue) => {
          return accumulator + currentValue[USAGES_CREDITS_COLUMN]
        },0);

        //TODAY&MAX
        let index;
        if(usages.dataset.filter(record => isSameDate(record[USAGES_INDEX_COLUMN], new Date(), "d")).length > 0){
          index = usages.dataset.findIndex(record => isSameDate(record[USAGES_INDEX_COLUMN], new Date(), "d"));
          // setUsagesStorageInUse(usages.dataset[index-1][USAGES_STORAGE_COLUMN]);
          setUsagesAssetsProcessedToday(usages.dataset[index][USAGES_ASSETS_COLUMN]);
        // }else{
        //   index = usages.dataset.length - 1;
        //   setUsagesStorageInUse(usages.dataset[index][USAGES_STORAGE_COLUMN]);
        }    

        setUsagesCreditsConsumed(
          usages.dataset.reduce((accumulator, currentValue) => {
            return accumulator + currentValue[USAGES_CREDITS_COLUMN]
          },0)
        );
        setUsagesAssetsProcessed(
          usages.dataset.reduce((accumulator, currentValue) => {
            return accumulator + currentValue[USAGES_ASSETS_COLUMN]
          },0)
        );   
        setUsagesStorageInUse(usages.dataset.filter(set => isSameDate(set[USAGES_INDEX_COLUMN], changeDate(new Date(),-1,"days"), "d")).reduce((accumulator, currentValue) => {
          return accumulator + currentValue[USAGES_STORAGE_COLUMN]
        },0));                 
        setUsagesTransferConsumed(
          usages.dataset.reduce((accumulator, currentValue) => {
            return accumulator + currentValue[USAGES_TRANSFER_COLUMN]
          },0)
        );

        setUsagesDoughnut({
          datasets: [{
            labels: [project.name, "Available credits"],
            data: [
              creditsConsumed,
              period.creditsRecharged - creditsConsumed
            ],
            borderWidth: 1,
            backgroundColor: [CHETWODEBLUE, "#ebebeb"]
          }]
        });
        let matrix = [];
        arrayOfDays.forEach((day, x) => {
          matrix.push({
            x: getWeekDay(day),
            y: getWeekOfYear(day),
            v: usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] === day).reduce((accumulator, currentValue) => {
              return accumulator + currentValue[USAGES_ASSETS_COLUMN]
            },0),
            date: day
          });
        });
        setUsagesHeatmap(matrix);

        setUsagesBarAssets({
          labels: arrayOfDays,
          datasets: [{
            label: project.name,
            data: arrayOfDays.map((day) => 
                    usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] === day).reduce((accumulator, currentValue) => {
                    return accumulator + currentValue[USAGES_ASSETS_COLUMN]
                  },0)
            ),
            backgroundColor: CHETWODEBLUE,
            tension: 0.1,
          }]
        });
        setUsagesLineMiniAssets({
          labels: arrayOfDays,
          datasets: [{
            data: arrayOfDays.map((day) => 
										new Date(day) <= new Date() ? 
                    	usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] <= day).reduce((accumulator, currentValue) => {
                    		return accumulator + currentValue[USAGES_ASSETS_COLUMN]
                  		},0)
										: 
											null
            			),
            borderColor: CHETWODEBLUE,
            tension: 0.1
          }]
        });

        setUsagesBarCredits({
          labels: arrayOfDays,
          datasets: [{
            label: project.name,            
            data: arrayOfDays.map((day) => 
                    usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] === day).reduce((accumulator, currentValue) => {
                    return accumulator + currentValue[USAGES_CREDITS_COLUMN]
                  },0)
            ),
            backgroundColor: CHETWODEBLUE,
            tension: 0.1,
          }]
        });
        setUsagesLineCredits({
          labels: arrayOfDays,
          datasets: [{
            data: arrayOfDays.map((day) => 
										new Date(day) <= new Date() ? 
                    	usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] <= day).reduce((accumulator, currentValue) => {
                    		return accumulator + currentValue[USAGES_CREDITS_COLUMN]
                  		},0)
										:
											null
									),
            borderColor: CHETWODEBLUE,
            tension: 0.1
          }]
        });
        setUsagesLineMiniCredits({
          labels: arrayOfDays,
          datasets: [{
            data: arrayOfDays.map((day) => 
										new Date(day) <= new Date() ? 
											usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] <= day).reduce((accumulator, currentValue) => {
												return accumulator + currentValue[USAGES_CREDITS_COLUMN]
                 			 },0)
										:
											 null
            				),
            borderColor: CHETWODEBLUE,
            tension: 0.1
          }]
        });
        setUsagesBarStorage({
          labels: arrayOfDays,
          datasets: [{
            label: project.name,          
            data: arrayOfDays.map((day) => 
                    usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] === day).reduce((accumulator, currentValue) => {
                    return accumulator + currentValue[USAGES_STORAGE_COLUMN]
                  },0)
            ),
            backgroundColor: CHETWODEBLUE,
            tension: 0.1,
          }]
        });
        setUsagesLineMiniStorage({
          labels: arrayOfDays,
          datasets: [{
            data: arrayOfDays.map((day) => 
										new Date(day) <= new Date() ? 
											usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] === day).reduce((accumulator, currentValue) => {
												return accumulator + currentValue[USAGES_STORAGE_COLUMN]
											},0)
										: 
											null
            				),
            borderColor: CHETWODEBLUE,
            tension: 0.1
          }]
        });
        setUsagesBarTransfer({
          labels: arrayOfDays,
          datasets: [{
            label: project.name,          
            data: arrayOfDays.map((day) => 
                    usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] === day).reduce((accumulator, currentValue) => {
                    return accumulator + currentValue[USAGES_TRANSFER_COLUMN]
                  },0)
            ),
            backgroundColor: CHETWODEBLUE,
            tension: 0.1,
          }]
        });
        setUsagesLineMiniTransfer({
          labels: arrayOfDays,
          datasets: [{
            data: arrayOfDays.map((day) => 
										new Date(day) <= new Date() ? 
											usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] === day).reduce((accumulator, currentValue) => {
												return accumulator + currentValue[USAGES_TRANSFER_COLUMN]
											},0)
										:
											null
            				),
            borderColor: CHETWODEBLUE,
            tension: 0.1
          }]
        });
      }).catch((error) => {
        setFetchError(formatError(error));
      });
    }
  }, [project, projectUuid, period, arrayOfDays]);

  

  useEffect(() => {
    if(detailedDay !== null){
      let params = {};
      params.projectUuid = projectUuid;
      params.grain = "h";
      params.hideTrivial = false;
      params.start = detailedDay;
      params.end = changeDate(detailedDay, 1, "days"); 
      UsagesService.listByProjects(params).then((usages) => {    
        console.log(usages);
        setUsagesDetailedBarCredits({
          labels: getArrayOfDayHours().map(item => getFormattedTime(item).slice(0,2)),
          datasets: [{
            label: project.name,      
            data: getArrayOfDayHours().map(item => getFormattedTime(item).slice(0,2)).map(hour => 
              usages.dataset.filter(set => getFormattedTime(set[USAGES_INDEX_COLUMN]).slice(0,2) === hour).reduce((accumulator, currentValue) => {
                return accumulator + currentValue[USAGES_CREDITS_COLUMN]
              },0)
            ),
            backgroundColor: CHETWODEBLUE,
            tension: 0.1,
          }]
        });
      }).catch((error) => {
        setFetchError(formatError(error));
      });
    }
  }, [project, projectUuid, dayForHourlyDetail, detailedDay]);
      
  useEffect(() => {
    if(checkPermission("period", "read") && checkPermission("period", "list")){
      AccountService.listPeriods().then((response) => {
        if(response && response.result){
          setPeriodHistory(response.result.slice(0, 6).reverse());
        }
      }).catch((error) => {
        setPeriodHistory(null);
        setFetchError(formatError(error));
      });
    }
    if(checkPermission("project", "list")){
      ProjectsService.list().then((response) => {
        setListProjects(response);
      });
    }
  }, []);

  

  return (
    <OzContainer size="extra">
      {project ? 
        <>
          <Meta title={project.name + " - Dashboard"} />
          <PageHeader
            breadcrumbsIcon="data_usage"
            breadcrumbsText={["Dashboard", project ? <OzProjectTag direction="horizontal" display="inline" name={project.name} uuid={project.uuid} color={project.color} /> : ""]}
            refScrollerPage={refScrollerPage}
            anchors={[
              checkPermission("period", "read") && checkPermission("period", "list") ? {
                "icon": "toll",
                "text": "Credits",
                "ref": scrollToCredits,
                "callback": () => {setCollapsedCredits(null); setTimeout( ()=> { setCollapsedCredits(false);},1)}
              } : null,
              checkPermission("period", "read") && checkPermission("period", "list") ? {
                "icon": "database",
                "text": "Storage",
                "ref": scrollToStorage,
                "callback": () => {setCollapsedStorage(null); setTimeout( ()=> { setCollapsedStorage(false);},1)}
              } : null,
              checkPermission("period", "read") && checkPermission("period", "list") ? {
                "icon": "cloud_download",
                "text": "Transfer",
                "ref": scrollToTransfer,
                "callback": () => {setCollapsedTransfer(null); setTimeout( ()=> { setCollapsedTransfer(false);},1)}
              } : null,
              checkPermission("period", "read") && checkPermission("period", "list") ? {
                "icon": "photo_library",
                "text": "Assets",
                "ref": scrollToAssets,
                "callback": () => {setCollapsedAssets(null); setTimeout( ()=> { setCollapsedAssets(false);},1)}
              } : null
            ]}
          />
        </>
      : null}

      <HealthyWrapper error={fetchError}>
        {checkPermission("period", "read") && checkPermission("period", "list") ? 
          <>
            <OzRow>
              {period && periodHistory && periodHistory.length > 1  ? periodHistory.map((val, i) => 
                <OzCol widthmd={2} key={i}>
                  <OzButton
                    width="100%"
                    variant={selectedPeriod === val.sequenceNumber ? "silvertree-o" : "push-black"}
                    onClick={() => setSelectedPeriod(val.sequenceNumber)}
                  >
                    {new Date(val.endDate) > new Date() ?
                      "Current"
                    :
                      getFormattedDate(val.startDate, false) + " - " + getFormattedDate(val.endDate, false)
                    }
                  </OzButton>
                </OzCol>
              ) : null }
            </OzRow>
            <br/>
            <OzRow>
              {usagesDoughnut && period && project ?
								<OzCol widthmd="12">    
									<DashGrid>
										<DashGridL1>
											<CreditsDashboard>
												<CreditsDashboardLeft>
													<OzCard
														height="100%"
														headerLeft={
															<>
																<CardHeaderTitle title={"Credits usage " + (usagesCreditsConsumed ? 
																	convertNumber(Math.round(
																		(usagesCreditsConsumed * 100 / period.creditsRecharged) * 10
																	) /10)
																: 0) + "%"}  />
															</>
														}
													>                
														<center>
															<div style={{"maxWidth": "400px"}}>
																<ChartWrapper width="170px">
																	<Doughnut
																		options={getChartOptions({type: "doughnut"})}
																		data={usagesDoughnut} 
																	/>
																</ChartWrapper>  
															</div>
																													
														</center>
													
													</OzCard>
												</CreditsDashboardLeft>
												<CreditsDashboardRight>
													<OzCard
														height="100%"
													> 
														<CreditsGrid slots={period.currentPlan.planType === "PAID" ? 3 : 3}>
															<CreditsGridBox>
																<CreditsGridLabel>Credits used during this period</CreditsGridLabel>
																<CreditsGridValue>{usagesCreditsConsumed ? convertNumber(usagesCreditsConsumed) : 0}  <small>of</small> {convertNumber(period.creditsRecharged)}</CreditsGridValue>
															</CreditsGridBox>
															<CreditsGridBox>
																<CreditsGridLabel>Consumed credits</CreditsGridLabel>
																<CreditsGridValue>{convertNumber(usagesCreditsConsumed)}</CreditsGridValue>
															</CreditsGridBox>
															<CreditsGridBox important>
																<CreditsGridLabel>Total credits</CreditsGridLabel>
																<CreditsGridValue>{convertNumber(period.creditsRecharged)}</CreditsGridValue>
															</CreditsGridBox>
														</CreditsGrid>
													</OzCard>
												</CreditsDashboardRight>
											</CreditsDashboard>
										</DashGridL1>
										<DashGridL2>
											<OzCard
                        height="100%"
                        headerLeft={
                          <CardHeaderTitle 
                            title={<><OzTooltip>Updated last night</OzTooltip> Storage in use</>}
                          />
                        }
                      >
                        {new Date(period.endDate) > new Date() ?
                          <MegaBadgeCnt>
                            <MegaBadge>{usagesStorageInUse ? convertSize(usagesStorageInUse) : 0}</MegaBadge>
                          </MegaBadgeCnt>
                          
                        : 
                          <NoLogSmall>The data is not available for this period.</NoLogSmall>    
                        }
                      </OzCard>
										</DashGridL2>
										<DashGridL3>
											<OzCard
                        height="100%"
                        headerLeft={
                          <CardHeaderTitle 
                            title={<><OzTooltip>Only transfer in download is charged; transfer in upload is free</OzTooltip> Data transfer consumed</>}
                          />
                        }
                      >
                        <MegaBadgeCnt>
                          <MegaBadge>{usagesTransferConsumed ? convertSize(usagesTransferConsumed) : 0}</MegaBadge>
                        </MegaBadgeCnt>
                      </OzCard>
										</DashGridL3>
										<DashGridR>
											<OzCard
												height="100%"
												headerLeft={
													<CardHeaderTitle 
														title={<><OzTooltip>Number of assets processed during the period</OzTooltip> Assets processed</>}
													/>
												}
											>               
												<AssetsCnt>
													<AssetsBlock>
														<OzRow>
															<OzCol widthmd={new Date(period.endDate) > new Date() ? "6" : "12"}>
																<MegaBadgeCnt>
																	<MegaBadge>{usagesAssetsProcessed ? convertNumber(usagesAssetsProcessed,2) : 0}</MegaBadge>
																</MegaBadgeCnt>
															</OzCol>
															{new Date(period.endDate) > new Date() ? 
																<OzCol widthmd="6">
																	<MegaBadgeCnt>
																		<MegaBadge variant="today">{usagesAssetsProcessedToday ? convertNumber(usagesAssetsProcessedToday) : 0}</MegaBadge>
																	</MegaBadgeCnt>
																	<center>Today</center>
																</OzCol>
															: null}
														</OzRow>
													</AssetsBlock>
													
													<Calendar>

														{usagesHeatmap && period.currentPlan.periodDuration === "MONTHLY" ? 
															<div style={{"maxWidth": "999px", "margin": "0 auto"}}>
																<Matrix
																	data={{
																		datasets: [{
																			data: usagesHeatmap,
																			borderWidth: 1,
																			borderColor: BORDER+"55",
																			backgroundColor(context) {
																				if(context.dataIndex){
																					const {ctx, chartArea} = context.chart;
																					const value = context.dataset.data[context.dataIndex].v;
																					let alpha, color;
																					// var angle = -1 * Math.atan2(chartArea.bottom - chartArea.top, chartArea.bottom) + Math.PI / 2;
																					
																					// var radius = chartArea.bottom - chartArea.top;
																					// var gx = radius * Math.cos(angle);
																					// var gy = radius * Math.sin(angle);
																					// var cx = (chartArea.left + chartArea.right) / 2;
																					// var cy = (chartArea.top + chartArea.bottom) / 2;
																					// var futureGradient = ctx.createLinearGradient(cx - gx, cy - gy, cx + gx, cy + gy);
																					var futureGradient = ctx.createLinearGradient(chartArea.left, chartArea.top, chartArea.right, chartArea.bottom);
																					// for(let i=0; i<0.98; i=i+0.02){
																					//   futureGradient.addColorStop(i, '#d3d3d3FF');   
																					//   futureGradient.addColorStop(i+0.008, '#d3d3d3FF');   
																					//   futureGradient.addColorStop(i+0.008, '#d3d3d300');   
																					//   futureGradient.addColorStop(i+0.020, '#d3d3d300');   
																					// }
																					let bgcolor = "#f1f1f1";
																					for(let i=0; i<0.96; i=i+0.04){
																						futureGradient.addColorStop(i, bgcolor+'FF');   
																						futureGradient.addColorStop(i+0.008, bgcolor+'FF');   
																						futureGradient.addColorStop(i+0.008, bgcolor+'00');   
																						futureGradient.addColorStop(i+0.040, bgcolor+'00');   
																					}
																					//"linear-gradient(0deg, rgba(211,211,211,0) 0%, rgba(211,211,211,0) 45%, rgba(211,211,211,1) 45%, rgba(211,211,211,1) 55%, rgba(211,211,211,0) 55%, rgba(211,211,211,0) 100%)";
																					
																					if(usagesHeatmap.map(item => item.v).reduce((p, v) => p > v ? p : v) > 0){
																						alpha = value * 100 / usagesHeatmap.map(item => item.v).reduce((p, v) => p > v ? p : v);
																					}else{
																						alpha = 0;
																					}

																					if(isSameDate(context.dataset.data[context.dataIndex].date, new Date(), "d")){
																						color = SILVERTREE+("00"+Math.round(alpha * 2.55).toString(16)).slice(-2);
																					}else if(new Date(context.dataset.data[context.dataIndex].date) > new Date()){
																						color = futureGradient;
																					}else{
																						color = "#0000ff"+("00"+Math.round(alpha * 2.55).toString(16)).slice(-2);
																					}
																					return color;
																				}else{
																					return "#0000ff00";
																				}
																			},
																			width: ({chart}) => (chart.chartArea || {}).width / 7,
																			height: ({chart}) => (chart.chartArea || {}).height / (getWeekOfYear(period.endDate) - getWeekOfYear(period.startDate) + 1),
																		}],
																	}}
																	options={getChartOptions({type: "calendar", vars: {period: period}})} 
																/>
															</div>
														: null}


													</Calendar>   
													<div></div>    
												</AssetsCnt>         
											</OzCard>

										</DashGridR>
									</DashGrid>
								</OzCol>            
              : null }
            </OzRow>
            <br/>
          </>
        : null }        
        <OzRow>     
          {checkPermission("period", "read") && checkPermission("period", "list") ? 
            <>
              {period ? 
                <OzCol> 
                <ScrollRef ref={scrollToAssets} />           
                  <OzCard
                    height="100%"
                    collapsible={true}
                    collapsed={collapsedAssets}
                    headerLeft={
                      <CardHeaderTitle 
                        title="Detail of the assets processed"
                        subtitle={<>Usage since {getFormattedDate(period.startDate)}{new Date(period.endDate) < new Date() ? " to " + getFormattedDate(period.endDate ? period.endDate : new Date()) : null}</>}
                      />
                    }
                    headerCenterCollapsed={
                      usagesLineMiniAssets ?
                        <MiniChartWrapper>
                          <Line options={getChartOptions({   
                              yScaleLabel: (val) => convertNumber(val),    
                              tooltipTitle: (val) => getFormattedDate(val), 
                              type: "line", 
                              isMini: true
                            })} data={usagesLineMiniAssets} />
                        </MiniChartWrapper>
                      : null
                    }
                    headerRight={
                      <CardPhrase>
                        <CardPhraseText>
                          Assets processed over the period
                          <CardPhraseSuperNumber>
                            {usagesAssetsProcessed ? convertNumber(usagesAssetsProcessed,0) : 0}
                          </CardPhraseSuperNumber>
                        </CardPhraseText>
                      </CardPhrase>
                    }
                    headerRightCollapsed={
                      <CardPhraseCollapsed>
                        <CardPhrase>
                          <CardPhraseText>
                            <CardPhraseSuperNumber>
                              {usagesAssetsProcessed ? convertNumber(usagesAssetsProcessed,0) : 0}
                            </CardPhraseSuperNumber>
                          </CardPhraseText>
                        </CardPhrase>
                      </CardPhraseCollapsed>
                    }
                  >
                    {usagesBarAssets ?
                      <Bar height="120px" options={getChartOptions({        
                        xScaleLabel: (i) => arrayOfDays.length <= 31 ? 
													[(new Date(arrayOfDays[i])).getDate(), getWeekDay(arrayOfDays[i]).substring(0,1)]
													:
													getFormattedDate(new Date(arrayOfDays[i])),   
                        yScaleLabel: (val) => convertNumber(val),    
                        tooltipTitle: (val) => getFormattedDate(val),
                        type: "bar"
                      })} data={usagesBarAssets} />
                    : <NoLog>No data available.</NoLog> }
                  </OzCard>
                </OzCol>
              : null }
            </>
          : null}
          {checkPermission("period", "read") && checkPermission("period", "list") ?                               
            <>
              {period ? 
                
                <OzCol>    
                  <ScrollRef ref={scrollToCredits} /> 
                  <OzCard
                    height="100%"
                    collapsible={true}
                    collapsed={collapsedCredits}
                    headerLeft={
                      <CardHeaderTitle 
                        title="Detail of the credits usage"
                        subtitle={<>Usage since {getFormattedDate(period.startDate)}{new Date(period.endDate) < new Date() ? " to " + getFormattedDate(period.endDate ? period.endDate : new Date()) : null}</>}
                      />
                    }
                    headerCenterCollapsed={
                      usagesLineMiniAssets ?
                        <MiniChartWrapper>
                          <Line options={getChartOptions({   
                              yScaleLabel: (val) => convertNumber(val),    
                              tooltipTitle: (val) => getFormattedDate(val), 
                              type: "line", 
                              isMini: true
                            })} data={usagesLineMiniCredits} />
                        </MiniChartWrapper>
                      : null
                    }
                    headerRight={
                      <CardPhrase>
                        <CardPhraseText>
                          Credits used over the period
                          <CardPhraseSuperNumber>
                            {usagesCreditsConsumed ? convertNumber(usagesCreditsConsumed,0) : 0}
                          </CardPhraseSuperNumber>
                        </CardPhraseText>
                      </CardPhrase>
                    }
                    headerRightCollapsed={
                      <CardPhraseCollapsed>
                        <CardPhrase>
                          <CardPhraseText>
                            <CardPhraseSuperNumber>
                              {usagesCreditsConsumed ? convertNumber(usagesCreditsConsumed,0) : 0}
                            </CardPhraseSuperNumber>
                          </CardPhraseText>
                        </CardPhrase>
                      </CardPhraseCollapsed>
                    }
                  >

                  {usagesBarCredits && usagesLineCredits ?
                    <>
                      <ChartModeContainer>
                        <ChartModeButton
                          active={graphMode === GRAPH_MODE_DELTA}
                          onClick={() => {
                            setGraphMode(GRAPH_MODE_DELTA);
                            setShowLimit(false);
                            setDayForHourlyDetail(null);
                            setDetailedDay(null);
                            setUsagesDetailedBarCredits(null);
                            
                          }}
                        >
                          <OzIcon name={"daily"} color={graphMode === GRAPH_MODE_DELTA ? "#ffffff" : "#303030"} size="15px" />&nbsp;Daily
                        </ChartModeButton>
                        <ChartModeButton
                          active={graphMode === GRAPH_MODE_SUM}
                          onClick={() => {
                            setGraphMode(GRAPH_MODE_SUM);
                            setDayForHourlyDetail(null);
                            setDetailedDay(null);
                            setUsagesDetailedBarCredits(null);
                          }}
                        >
                          <OzIcon name={"sum"} color={graphMode === GRAPH_MODE_SUM ? "#ffffff" : "#303030"} size="15px" />&nbsp;Sum
                        </ChartModeButton>
                        {project.creditLimit ?
                          <ChartModeButton
                            active={showLimit}
                            onClick={() => setShowLimit(!showLimit)}
                          >
                            <OzIcon name={"plan-limit"} color={showLimit ? "#ffffff" : "#303030"} size="15px" />&nbsp;Limit
                          </ChartModeButton>
                        : null }
                      </ChartModeContainer>
                        {graphMode === GRAPH_MODE_DELTA ?
                          <Bar height="120px" options={getChartOptions({
                            onClick: (i) => {
                              setDetailedDay(arrayOfDays[i]);
                            },
                            xScaleLabel: (i) => arrayOfDays.length <= 31 ? 
															[(new Date(arrayOfDays[i])).getDate(), getWeekDay(arrayOfDays[i]).substring(0,1)]
															:
															getFormattedDate(new Date(arrayOfDays[i])),   
                            yScaleLabel: (val) => convertNumber(val),    
                            tooltipTitle: (val) => getFormattedDate(val),
                            type: "bar"
                          })} data={usagesBarCredits} />
                        : null }
                        {graphMode === GRAPH_MODE_SUM ?
                          <Line height="120px" options={getChartOptions({  
                            onClick: (i) => {
                              setGraphMode(GRAPH_MODE_DELTA);
                              setDetailedDay(arrayOfDays[i]);
                            },
                            xScaleLabel: (i) => arrayOfDays.length <= 31 ? 
															[(new Date(arrayOfDays[i])).getDate(), getWeekDay(arrayOfDays[i]).substring(0,1)]
															:
															getFormattedDate(new Date(arrayOfDays[i])),   
                            yScaleLabel: (val) => convertNumber(val),    
                            tooltipTitle: (val) => getFormattedDate(val), 
                            type: "line", 
                          })} data={usagesLineCredits} />
                        : null }
                        {detailedDay && usagesDetailedBarCredits ?
                          <>
                            <hr/>
                            <CardHeaderTitle 
                              title="Hourly credits usage"
                              subtitle={<>Usage: {getFormattedDate(detailedDay)}</>}
                            />

                            {graphMode === GRAPH_MODE_DELTA ?
                              <Bar height="120px" options={getChartOptions({
                                tooltipTitle: (val) => val+":00",
                                type: "bar"
                              })} data={usagesDetailedBarCredits} />
                            : null }
                          </>
                        : null }
                      </>
                    : <NoLog>No data available.</NoLog> }
                  </OzCard>
                </OzCol>
              : null }
            </>
          : null}
          {checkPermission("period", "read") && checkPermission("period", "list") ? 
            <>
              {period ? 
                <OzCol>
                  <ScrollRef ref={scrollToStorage} /> 
                  <OzCard
                    height="100%"
                    collapsible={true}
                    collapsed={collapsedStorage}
                    headerLeft={
                      <CardHeaderTitle 
                        title="Detail of the storage usage"
                        subtitle={<>Usage since {getFormattedDate(period.startDate)}{new Date(period.endDate) < new Date() ? " to " + getFormattedDate(period.endDate ? period.endDate : new Date()) : null}</>}
                      />
                    }
                    headerCenterCollapsed={
                      usagesLineMiniAssets ?
                        <MiniChartWrapper>
                          <Line options={getChartOptions({   
                              yScaleLabel: (val) => convertNumber(val),    
                              tooltipTitle: (val) => getFormattedDate(val), 
                              type: "line", 
                              isMini: true
                            })} data={usagesLineMiniStorage} />
                        </MiniChartWrapper>
                      : null
                    }
                    headerRight={
                      <CardPhrase>
                        <CardPhraseText>
                          Storage used over the period
                          <CardPhraseSuperNumber>
                            {usagesStorageInUse ? convertSize(usagesStorageInUse,2) : 0}
                          </CardPhraseSuperNumber>
                        </CardPhraseText>
                      </CardPhrase>
                    }
                    headerRightCollapsed={
                      <CardPhraseCollapsed>
                        <CardPhrase>
                          <CardPhraseText>
                            <CardPhraseSuperNumber>
                              {usagesStorageInUse ? convertSize(usagesStorageInUse,2) : 0}
                            </CardPhraseSuperNumber>
                          </CardPhraseText>
                        </CardPhrase>
                      </CardPhraseCollapsed>
                    }
                  >
                    {usagesBarStorage ?
                      <Bar height="120px" options={getChartOptions({        
                       	xScaleLabel: (i) => arrayOfDays.length <= 31 ? 
														[(new Date(arrayOfDays[i])).getDate(), getWeekDay(arrayOfDays[i]).substring(0,1)]
													:
														getFormattedDate(new Date(arrayOfDays[i])),   
                        yScaleLabel: (val) => convertNumber(val),    
                        tooltipTitle: (val) => getFormattedDate(val),
                        type: "bar"
                      })} data={usagesBarStorage} />
                    : <NoLog>No data available.</NoLog> }
                  </OzCard>
                </OzCol>
              : null }
              </>
            : null}
            {checkPermission("period", "read") && checkPermission("period", "list") ? 
              <>
              {period ? 
                <OzCol>      
                  <ScrollRef ref={scrollToTransfer} />      
                  <OzCard
                    height="100%"
                    collapsible={true}
                    collapsed={collapsedTransfer}
                    headerLeft={
                      <CardHeaderTitle 
                        title="Detail of the data transfer"
                        subtitle={<>Usage since {getFormattedDate(period.startDate)}{new Date(period.endDate) < new Date() ? " to " + getFormattedDate(period.endDate ? period.endDate : new Date()) : null}</>}
                      />
                    }
                    headerCenterCollapsed={
                      usagesLineMiniAssets ?
                        <MiniChartWrapper>
                          <Line options={getChartOptions({   
                              yScaleLabel: (val) => convertNumber(val),    
                              tooltipTitle: (val) => getFormattedDate(val), 
                              type: "line", 
                              isMini: true
                            })} data={usagesLineMiniTransfer} />
                        </MiniChartWrapper>
                      : null
                    }
                    headerRight={
                      <CardPhrase>
                        <CardPhraseText>
                          Data transfer used over the period
                          <CardPhraseSuperNumber>
                            {usagesTransferConsumed ? convertSize(usagesTransferConsumed,2) : 0}
                          </CardPhraseSuperNumber>
                        </CardPhraseText>
                      </CardPhrase>
                    }
                    headerRightCollapsed={
                      <CardPhraseCollapsed>
                        <CardPhrase>
                          <CardPhraseText>
                            <CardPhraseSuperNumber>
                            {usagesTransferConsumed ? convertSize(usagesTransferConsumed,2) : 0}
                            </CardPhraseSuperNumber>
                          </CardPhraseText>
                        </CardPhrase>
                      </CardPhraseCollapsed>
                    }
                  >
                    {usagesBarTransfer ?
                      <Bar height="120px" options={getChartOptions({        
                        xScaleLabel: (i) => arrayOfDays.length <= 31 ? 
														[(new Date(arrayOfDays[i])).getDate(), getWeekDay(arrayOfDays[i]).substring(0,1)]
													:
														getFormattedDate(new Date(arrayOfDays[i])),   
                        yScaleLabel: (val) => convertNumber(val),    
                        tooltipTitle: (val) => getFormattedDate(val),
                        type: "bar"
                      })} data={usagesBarTransfer} />
                    : <NoLog>No data available.</NoLog> }
                  </OzCard>
                </OzCol>
              : null }
            </>
          : null}
          
          {checkPermission("log", "list") ? 
            <OzCol>
              <OzCard
                height="100%"
                headerLeft={<CardHeaderTitle title="Last logs" />}
                footerRight={
                  <Link to={"/project/"+projectUuid+"/logs"}>
                    <Detail>Detail</Detail>
                  </Link>
                }
              >
                {logs && logs.length > 0 ?
                  <LogTableWrapper>
                    <OzTable
                      columns={[
                        "Date",
                        "Time",
                        "File name",
                        "Activity",
                        "Size",
                        <center>Cost</center>,
                        <center>Exec</center>
                      ]}
                      values={
                        logs.slice(0,5).map(item => ({
                          style: {
                            color: item.result === "ERROR" ? "#FF4848" : null
                          },
                          id: item.document.id,
                          accordion: <Accordion>
                            <AccordionLeft full={item.document.result !== "ERROR" && item.document.result !== "WARNING"}>
                              <table>
																<tbody>
																	<LogRow>
																		<LogKey>Date</LogKey>
																		<LogValue>{getFormattedDate(item.document.create_datetime)}</LogValue>
																	</LogRow>
																	<LogRow>
																		<LogKey>Time</LogKey>
																		<LogValue>{getFormattedTime(item.document.create_datetime)}</LogValue>
																	</LogRow>
																	{item.document.source_file_key ? 
																		<LogRow>
																			<LogKey>Source file name</LogKey>
																			<LogValue>
																				<OzCopyable>{item.document.source_file_key.substring(item.document.source_file_key.lastIndexOf('/')+1)}</OzCopyable>
																			</LogValue>
																		</LogRow>
																	: null}
																	{item.document.source_file_size ? 
																		<LogRow>
																			<LogKey>Source file size</LogKey>
																			<LogValue>{convertSize(item.document.source_file_size)}</LogValue>
																		</LogRow>
																	: null}
																	{/* {item.document.user_uuid ? 
																		<LogRow>
																			<LogKey>Company</LogKey>
																			<LogValue> 
																				{listUsers.filter(val => val.uuid === item.document.user_uuid).length > 0 ?
																					listUsers.filter(val => val.uuid === item.document.user_uuid).map(user =>
																						user.company
																					)
																				: "-"}
																			</LogValue>
																		</LogRow>
																	: null}
																	{item.document.user_uuid ? 
																		<LogRow>
																			<LogKey>User</LogKey>
																			<LogValue> 
																				{listUsers.filter(val => val.uuid === item.document.user_uuid).length > 0 ?
																					listUsers.filter(val => val.uuid === item.document.user_uuid).map(user =>
																						user.givenName + " " + user.familyName
																					)
																				: "-"}
																			</LogValue>
																		</LogRow>
																	: null} */}
																	{item.document.project_uuid ? 
																		<LogRow>
																			<LogKey>Project</LogKey>
																			<LogValue> 
																				{listProjects.filter(val => val.uuid === item.document.project_uuid).length > 0 ?
																					listProjects.filter(val => val.uuid === item.document.project_uuid).map(project =>
																						project.name
																					)
																				: "-"}
																			</LogValue>
																		</LogRow>
																	: null}
																	{item.document.project_uuid ? 
																		<LogRow>
																			<LogKey>Project ID</LogKey>
																			<LogValue> 
																				<OzCopyable>{item.document.project_uuid}</OzCopyable>
																			</LogValue>
																		</LogRow>
																	: null}
																	{item.document.consumer_type ? 
																		<LogRow>
																			<LogKey>Consumer type</LogKey>
																			<LogValue>{item.document.consumer_type}</LogValue>
																		</LogRow>
																	: null}
																	{item.document.script_name ? 
																		<LogRow>
																			<LogKey>Script</LogKey>
																			<LogValue>{item.document.script_name}</LogValue>
																		</LogRow>
																	: null}
																	{item.document.destination_type ? 
																		<LogRow>
																			<LogKey>Destination type</LogKey>
																			<LogValue>{item.document.destination_type}</LogValue>
																		</LogRow>
																	: null}
																	{item.document.processing_time_ms ? 
																		<LogRow>
																			<LogKey>Process time (ms)</LogKey>
																			<LogValue>{item.document.processing_time_ms}</LogValue>
																		</LogRow>
																	: null}
																	{item.document.response_size ? 
																		<LogRow>
																			<LogKey>Response size</LogKey>
																			<LogValue>{convertSize(item.document.response_size)}</LogValue>
																		</LogRow>
																	: null}
																	{item.document.assets_processed ? 
																		<LogRow>
																			<LogKey>Assets processed</LogKey>
																			<LogValue>{item.document.assets_processed}</LogValue>
																		</LogRow>
																	: null}
																	{item.document.credit_price ? 
																		<LogRow>
																			<LogKey>Credit price</LogKey>
																			<LogValue>{item.document.credit_price}</LogValue>
																		</LogRow>
																	: null}
																	{item.document.transfer_bytes ? 
																		<LogRow>
																			<LogKey>Transfer bytes</LogKey>
																			<LogValue>{convertSize(item.document.transfer_bytes)}</LogValue>
																		</LogRow>
																	: null}
																	{item.document.storage_bytes ? 
																		<LogRow>
																			<LogKey>Storage bytes</LogKey>
																			<LogValue>{convertSize(item.document.storage_bytes)}</LogValue>
																		</LogRow>
																	: null}
																	{item.document.job_uuid ? 
																		<LogRow>
																			<LogKey>Job ID</LogKey>
																			<LogValue>
																				<OzCopyable>{item.document.job_uuid}</OzCopyable>
																			</LogValue>
																		</LogRow>
																	: null}
																</tbody>
                              </table>
                            </AccordionLeft>
                            {item.document.result === "ERROR" || item.document.result === "WARNING" ?
                              <AccordionRight>
                              
                                <table>
																	<tbody>
																		{item.document.error_code ? 
																			<LogRow>
																				<LogKey>Error</LogKey>
																				<LogValue>{item.document.error_code}</LogValue>
																			</LogRow>
																		: null}
																		{item.document.error_description ? 
																			<LogRow>
																				<LogKey>Description</LogKey>
																				<LogValue>{item.document.error_description}</LogValue>
																			</LogRow>
																		: null}
																		{item.document.error_scope ? 
																			<LogRow>
																				<LogKey>Type</LogKey>
																				<LogValue>{item.document.error_scope}</LogValue>
																			</LogRow>
																		: null}
																	</tbody>
                                </table>
                              </AccordionRight>
                            : null}
                          </Accordion>,
                          values: [
                            <Dark>
                              {getFormattedDate(item.document.create_datetime)}
                            </Dark>,
                            <Light>
                              {getFormattedTime(item.document.create_datetime)}
                            </Light>,
                            <Dark>
                              {item.document.source_file_key ? 
                                ((item.document.source_file_key.substring(item.document.source_file_key.lastIndexOf('/')+1))
                                .length > 20 ? 
                                  item.document.source_file_key.substring(item.document.source_file_key.lastIndexOf('/')+1)
                                  .slice(0, 17)
                                  +"..."
                                :
                                  item.document.source_file_key.substring(item.document.source_file_key.lastIndexOf('/')+1)
                                )
                              : null}
                            </Dark>,
                            <Dark>
                              {item.document.consumer_type === "SCRIPT" ? 
                                item.document.script_name
                              :
                                item.document.consumer_type
                              }
                            </Dark>,
                            item.document.consumer_type === "STORAGE" ?
                              convertSize(item.document.storage_in_use)
                            : item.document.consumer_type === "TRANSFER" ?
                              convertSize(item.document.transfer_consumed)
                            :
                              convertSize(item.document.destination_file_size),
                            <LogCost>{item.document.credit_price}</LogCost>,
                            <LogExecution status={item.document.result}>
                              <span className="material-symbols-outlined">{
                                item.document.result === "SUCCESS" ? 
                                  "done"
                                : item.document.result === "WARNING" ? 
                                  "warning"
                                : item.document.result === "ERROR" ? 
                                  "close"
                                : item.document.result === "ONGOING" ? 
                                  "hourglass_empty"
                                : null
                              }</span>
                            </LogExecution>
                          ]
                        }))
                      }
                    />
                  </LogTableWrapper>
                :
                  <NoLog>No log during this period.</NoLog>
                }
              </OzCard>
            </OzCol>
          : null }
        </OzRow>
      </HealthyWrapper>
    </OzContainer>
  )
}

export default Dashboard;